import { render, staticRenderFns } from "./RegisteredWithoutToken.vue?vue&type=template&id=bd806554"
import script from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"
export * from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports